// // Action names should be imported from their respective action modules
import {
    SAS_BEGIN,
    SAS_SUCCESS,
    SAS_FAILURE
} from '../actions/SasActions';

// Example initial state
const initialState = {
    item: {},
    isLoading: false,
    error: ''
};

// Return a new state object with updated attributes
export default function SasReducer(state = initialState, action) {
    switch (action.type) {
        case SAS_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case SAS_SUCCESS:
            return {
                ...state,
                item: action.payload.data,
                isLoading: false,
                error: ''
            }
        case SAS_FAILURE:
            return {
                ...state,
                error: action.payload.error,
                isLoading: false
            }
        default:
            return state;
    }
};


export const sasError = state => {
    return state.error;
}

export const sasIsLoading = state => {
    return state.isLoading;
}

export const sas = state => {
    return state.item;
}